export let greeting = "hello world"; 